var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 11.408 7.204"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.704.704l5 6 5-6",
    fill: "none",
    stroke: "#919191",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "e73ab766262f634dc6ffea8a226e2f8d.svg";
export { SvgArrowIcon as ReactComponent };